export default "__VITE_ASSET__d8ec528e__"